import React from "react";
import { useRoleAccess } from "./useRoleAccess";

interface RoleGuardProps {
  allowedRoles: ("ADMIN" | "SUPER_ADMIN")[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const RoleGuard: React.FC<RoleGuardProps> = ({
  allowedRoles,
  children,
  fallback = null,
}) => {
  const { hasAccess } = useRoleAccess();

  if (!hasAccess(allowedRoles)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
